'use client'

import { ReactNode, useEffect, useState } from 'react'

import DialogComponent from '@/components/Context/DialogProvider/Dialog'
import useBackActionModalListener from '@/components/hooks/useBackActionModalListener'
import { useEvent } from '@/components/hooks/useRecordEvent'

export default function BrowserBack({
  measurementId = null,
  children,
}: {
  measurementId?: string | null
  children: ReactNode
}) {
  const [dialog, setDialog] = useState<boolean>(false)
  const { isModalOpen, closeModal } = useBackActionModalListener()

  const { record } = useEvent()

  useEffect(() => {
    if (isModalOpen) {
      setDialog(true)
      if (measurementId) {
        record('browser_back_popup', {
          measurementId,
        })
      }
    }
  }, [isModalOpen])

  return (
    <>
      <DialogComponent
        show={dialog}
        afterSubmit={() => {
          setDialog(false)
          closeModal()
        }}
        key={dialog.toString()}
        controlScroll={false}
      >
        {children}
      </DialogComponent>
    </>
  )
}
